import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';

import { formatDateByTimeZone } from '@app/shared';
import { MeetingsBffService } from '@core/services';
import { ChangableComponent } from '@models/changable.component';
import {
  Classroom,
  EContentOrder,
  MeetingStatusEnum,
  Router as ContentRouter,
  User,
  type Meeting,
} from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-user-service-meetings',
  templateUrl: './user-service-meetings.component.html',
  styleUrls: ['./user-service-meetings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserServiceMeetingsComponent extends ChangableComponent implements OnInit {
  protected meetingsBffService = inject(MeetingsBffService);
  deviceService = inject(DeviceDetectorService);

  @Input()
  public user_service_id: string;

  @Input()
  public me: User;

  public meeting: Meeting;
  public limit = 1;
  public meetingCheckoutDialogOpened: boolean;

  ngOnInit(): void {
    this.loadMeetings();
  }

  private loadMeetings() {
    this.meetingsBffService
      .getList({
        strategy: 'upcoming-by-user-service',
        filter: { user_service_id: this.user_service_id },
        pagination: { page: 1, pageSize: 1 },
        order: EContentOrder.date_asc,
      })
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          this.meeting = res.list[0];
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        },
      });
  }

  public classroomRoute(classroom: Classroom): string[] {
    return ContentRouter.classroomRoute(classroom);
  }

  public get isAcceptRequired() {
    return this.meeting.status === MeetingStatusEnum.accept_required;
  }

  public onPaymentSucceed() {
    this.meetingCheckoutDialogOpened = false;
    this.meeting.status = MeetingStatusEnum.accepted;
    this.detectChanges();
  }

  public formatDate(date) {
    return formatDateByTimeZone(date, this.me.timezone);
  }
}
